export default "__VITE_ASSET__Bpwh6Ms8__"